import React, { Component } from "react";
import Datas from "../data/footer/footer.json";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import { Styles } from "./styles/footerOne.js";

class Footer extends Component {
  render() {
    return (
      <Styles>
        {/* Footer Area */}
        <footer
          className="footer1"
          style={{
            backgroundImage: `url(assets/images/${
              process.env.PUBLIC_URL + Datas.backgroundImage
            })`,
          }}
        >
          <Container>
            <Row>
              <Col md="4">
                <div className="footer-logo-info">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                    alt="Swiss School"
                    className="img-fluid"
                  />
                  <p>
                    Swiss School empowers learners worldwide with personalised
                    counselling, curated programs, and end-to-end admissions
                    support.
                  </p>
                  <ul className="list-unstyled">
                    <li>
                      <i className="las la-map-marker"></i>Topaz Building,
                      Punjagutta, Hyderabad
                    </li>
                    <li>
                      <i className="las la-envelope"></i>contact@swissschools.in
                    </li>
                    <li>
                      <i className="las la-phone"></i>+91 90523 78789
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md="4">
                <div className="f-links">
                  <h5>Quick Links</h5>
                  <ul className="list-unstyled">
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/about"}>
                        <i className="las la-angle-right"></i>About Swiss School
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/courses"}>
                        <i className="las la-angle-right"></i>Find Courses
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={process.env.PUBLIC_URL + "/instructor"}>
                        <i className="las la-angle-right"></i>Meet Our
                        Instructors
                      </Link>
                    </li> */}
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/events"}>
                        <i className="las la-angle-right"></i>Upcoming Events
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/contact"}>
                        <i className="las la-angle-right"></i>Contact & Support
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md="4">
                <div className="f-post">
                  <h5>Recent Resources</h5>
                  <div className="post-box d-flex">
                    <div className="post-img">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/blog-2.jpg"
                        }
                        alt=""
                      />
                    </div>
                    <div className="post-content">
                      <Link to={process.env.PUBLIC_URL + "/blog-details"}>
                        How to choose the right study destination
                      </Link>
                      <span>Jul 22, 2024</span>
                    </div>
                  </div>
                  <div className="post-box d-flex">
                    <div className="post-img">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/blog-3.jpg"
                        }
                        alt=""
                      />
                    </div>
                    <div className="post-content">
                      <Link to={process.env.PUBLIC_URL + "/blog-details"}>
                        Funding options for international students
                      </Link>
                      <span>Jun 15, 2024</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>

        {/* Copyright Area */}
        <section className="copyright-area">
          <Container>
            <Row>
              <Col md="6">
                <div className="copy-text">
                  <p>
                    Copyright &copy; {new Date().getFullYear()} | Swiss School.
                    All rights reserved.
                  </p>
                </div>
              </Col>
              <Col md="6" className="text-right">
                <span className="footer-contact">
                  Need help? Email{" "}
                  <a href="mailto:contact@swissschools.in">
                    contact@swissschools.in{" "}
                  </a>
                </span>
              </Col>
            </Row>
          </Container>

          {/* Back To Top */}
          <BackToTop />
        </section>
      </Styles>
    );
  }
}

export default Footer;
